import { useNavigate } from "@solidjs/router";
import SmartSearchPanel from "./SmartSearchPanel";

// Route wrapper for /smartSearch — kept so anything that navigates here
// directly keeps working. The actual UI lives in SmartSearchPanel so it can
// also be shown inline (see Home.tsx, where selecting the search icon in
// the header shows this without navigating away and losing the header row).
const SmartSearchPage = () => {
    const navigate = useNavigate();

    return <SmartSearchPanel onEscape={() => navigate(-1)} />;
};

export default SmartSearchPage;